import { useQpmCalculationListQuery } from "@/services/backend/qpm/calculations/api/calculation-api";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/shared/components/ui/table";
import t from "@/lang/lang";
import { NavLink } from "react-router";
import { Button } from "@/shared/components/ui/button";
import { Search } from "lucide-react";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { DocumentNumberById } from "@/services/backend/numbers/components/document-number";
import { Calculation } from "@/services/backend/qpm/calculations/types/calculation";

export function CalculationListTable(props: { processId: string }) {
  const { processId } = props;

  const {
    data: list,
    isLoading,
    error,
  } = useQpmCalculationListQuery({
    process: {
      active: true,
      values: [processId],
    },
    customer: {
      active: false,
      values: [],
    },
  });

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (isLoading) {
    return (
      <Table className="animate-pulse">
        <TableHeader>
          <TableRow>
            <TableHead className="w-24">{t("Aktuelle")}</TableHead>
            <TableHead>{t("Nummer")}</TableHead>
            <TableHead>{t("Erstellt am")}</TableHead>
            <TableHead className="w-32">{t("Aktionen")}</TableHead>
          </TableRow>
        </TableHeader>
      </Table>
    );
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>{t("Nummer")}</TableHead>
          <TableHead className="w-full">{t("Erstellt am")}</TableHead>
          <TableHead className="w-48">{t("Aktionen")}</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {[...(list?.items ?? [])].sort(byCreatedAt).map((calculation) => (
          <TableRow key={calculation.id}>
            <TableCell>
              <NavLink to={`${calculation.id}`}>
                <DocumentNumberById documentId={calculation.id} />
              </NavLink>
            </TableCell>
            <TableCell>
              {new Date(calculation.createdAt).toLocaleDateString()}
            </TableCell>
            <TableCell className="text-right">
              <NavLink to={`${calculation.id}`}>
                <Button variant="outline" size="sm">
                  <Search className="h-4 w-4" />
                </Button>
              </NavLink>
            </TableCell>
          </TableRow>
        ))}
        {list?.items?.length === 0 && (
          <TableRow>
            <TableCell colSpan={5} className="text-center">
              {t("Keine Kalkulationen gefunden")}
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
}

function byCreatedAt(a: Calculation, b: Calculation) {
  return a.createdAt.localeCompare(b.createdAt);
}
